import { IBaseAddress } from '../../types'

export function getAddressLabel({
  name1,
  street,
  streetNumber,
  streetNumberAddition,
  zip,
  city,
  country,
}: IBaseAddress): string {
  return [
    name1,
    [street, streetNumber, streetNumberAddition].filter(Boolean).join(' '),
    [zip, city].filter(Boolean).join(' '),
    country,
  ]
    .filter(Boolean)
    .join(', ')
}

export function isProbablyBarcode(text: string): boolean {
  const numbers = text.replace(/^\D+/g, '')
  return numbers.length >= 6
}
